/**
 * PoppinPay API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CalculationPhase from './CalculationPhase';
import InclusionType from './InclusionType';

/**
* The Tax model module.
* @module model/Tax
* @version 1.0.0
*/
export default class Tax {
    /**
    * Constructs a new <code>Tax</code>.
    * @alias module:model/Tax
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>Tax</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/Tax} obj Optional instance to populate.
    * @return {module:model/Tax} The populated <code>Tax</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Tax();
                        
            
            if (data.hasOwnProperty('Id')) {
                obj['Id'] = ApiClient.convertToType(data['Id'], 'String');
            }
            if (data.hasOwnProperty('Name')) {
                obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
            }
            if (data.hasOwnProperty('Percentage')) {
                obj['Percentage'] = ApiClient.convertToType(data['Percentage'], 'String');
            }
            if (data.hasOwnProperty('CalculationPhase')) {
                obj['CalculationPhase'] = CalculationPhase.constructFromObject(data['CalculationPhase']);
            }
            if (data.hasOwnProperty('InclusionType')) {
                obj['InclusionType'] = InclusionType.constructFromObject(data['InclusionType']);
            }
        }
        return obj;
    }

    /**
    * @member {String} Id
    */
    'Id' = undefined;
    /**
    * @member {String} Name
    */
    'Name' = undefined;
    /**
    * @member {String} Percentage
    */
    'Percentage' = undefined;
    /**
    * @member {module:model/CalculationPhase} CalculationPhase
    */
    'CalculationPhase' = undefined;
    /**
    * @member {module:model/InclusionType} InclusionType
    */
    'InclusionType' = undefined;




}
